import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Reaction } from '../../../../clubs/interface/reaction.interface';
import { ReactionType } from '../../../../models/clubs/reaction-type.model';
import { ReactionTypeService } from '../../../../services/clubs/reaction-type.service';

@Component({
    selector: 'add-reaction-button',
    template: `
        <button
            pButton
            pRipple
            type="button"
            styleClass="p-my-auto"
            [ngClass]="getButtonClasses()"
            class="p-button-text p-button-plain p-my-1 p-px-xl-6 p-px-lg-6 p-px-md-4 p-px-sm-3"
            (click)="handleAddReaction(currentReactionData.code)"
            icon="{{ isDefaultReaction ? 'pi pi-thumbs-up' : '' }}"
            [label]="currentReactionLabel"
            [@reactionAnimation]="reactionState"
        ></button>
    `,
    animations: [
        trigger('reactionAnimation', [
            state('default', style({ transform: 'scale(1)' })),
            state('selected', style({ transform: 'scale(1)' })),
            transition('default <=> selected', [
                animate('200ms ease-in', style({ transform: 'scale(1.2)' })),
                animate('200ms ease-out', style({ transform: 'scale(1)' })),
            ]),
        ]),
    ],
    styleUrls: ['./add-reaction-button.component.scss'],
})
export class AddReactionButtonComponent implements OnInit {
    public defaultReaction: Reaction = { code: '👍🏻', label: 'clubs.page.common.reactions.like', cssClass: '' };
    public currentReactionData: Reaction = this.defaultReaction;
    public isDefaultReaction = true;
    @Output() public onReactionAdded = new EventEmitter<string>();

    @HostBinding('@reactionAnimation') public reactionState: 'default' | 'selected' = 'default';
    public reactionTypes: ReactionType[] = [];
    public reactions: Reaction[] = [
        { code: '👍🏻', label: 'clubs.page.common.reactions.like', cssClass: 'reaction camel' },
        { code: '❤️', label: 'clubs.page.common.reactions.love', cssClass: 'reaction red' },
        { code: '😂', label: 'clubs.page.common.reactions.laughing', cssClass: 'reaction yellow' },
        { code: '😮', label: 'clubs.page.common.reactions.oh', cssClass: 'reaction yellow' },
        { code: '😢', label: 'clubs.page.common.reactions.sad', cssClass: 'reaction yellow' },
        { code: '😡', label: 'clubs.page.common.reactions.angry', cssClass: 'reaction red' },
    ];

    constructor(readonly reactionTypeService: ReactionTypeService, readonly translate: TranslateService) {}

    @Input()
    public set currentReaction(value: string) {
        this.propertyChanged(value);
    }

    public currentReactionLabel: string;

    public handleAddReaction(reactionCode: string) {
        this.switchAnimation();
        const reactionId = this.reactionTypes.find((reactionType) => reactionType.code === reactionCode)?.id;
        this.onReactionAdded.emit(reactionId);
    }

    public ngOnInit() {
        this.reactionTypeService.getAllReactionTypes().subscribe((result) => {
            this.reactionTypes = result;
            this.setCurrrentReaction(this.currentReaction);
        });
    }

    public setCurrrentReaction(value?: string) {
        const reactionCode = this.reactionTypes.find((reactionType) => reactionType.id === value)?.code;
        if (!reactionCode) {
            this.currentReactionData = this.defaultReaction;
            this.currentReactionLabel = this.translate.instant(this.currentReactionData.label);
            this.isDefaultReaction = true;
        } else {
            this.currentReactionData = this.reactions.find((reaction) => reaction.code === reactionCode);
            this.currentReactionLabel = this.currentReactionData.code + ' ' + this.translate.instant(this.currentReactionData.label);
            this.isDefaultReaction = false;
        }
    }

    public switchAnimation() {
        this.reactionState = this.reactionState === 'default' ? 'selected' : 'default';
    }

    private propertyChanged(value: string) {
        this.switchAnimation();
        this.setCurrrentReaction(value);
    }

    public getButtonClasses() {
        return {
            [this.currentReactionData.cssClass]: true,
        };
    }
}
